import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'SelfServeBuilder';
import ReactTooltip from 'react-tooltip';
import { PrimaryButton } from 'DesignSystem/Buttons';

export default class PublicLinkToggle extends React.PureComponent {
  constructor(props) {
    super(props);

    this.togglePublicLink = this.togglePublicLink.bind(this);
  }

  togglePublicLink() {
    window._track(`Turn ${this.props.isToggledOn ? 'Off' : 'On'} | Share Link`, 'Template Builder');
    this.props.togglePublish(this.props.documentType, !this.props.isToggledOn);
  }

  render() {
    const buttonIconText = this.props.isToggledOn ? 'Turn Off' : 'Turn On';
    const buttonText = this.props.isToggledOn ? 'Turn Off' : 'Get Link';

    const toggledOnText = "Turn off the link to stop collecting responses. (Turn it on again at any time.) Direct requests from 'Add Recipients' will still have access to the template.";
    const toggledOffText = 'Turn on link to allow anyone with the link to access an individual copy of your template to fill out.';
    const tooltipText = this.props.isToggledOn ? toggledOnText : toggledOffText;

    const pillButtonClasses = this.props.isToggledOn ? 'pill-button active' : 'pill-button inactive';
    const publicLinkStatus = this.props.isToggledOn ? 'ON' : 'OFF';
    const iconClass = this.props.isIcon ? '' : 'vertical-center-align';

    return (
      <div className={`public-link-toggle ${iconClass}`}>
        <div className={`public-link-title ${iconClass}`}>Link is</div>
        <div className={`${pillButtonClasses} ${iconClass}`}>
          {publicLinkStatus}
        </div>
        {
          this.props.isIcon &&
          <IconButton
            imageWidth={0}
            text={buttonIconText}
            onClick={this.togglePublicLink}
            tooltipText={tooltipText}
            tooltipPlacement="bottom"
          />
        }
        {
          !this.props.isIcon &&
          <div
            className="right"
            data-class="empty-template-tooltip"
            data-delay-hide="50"
            data-tip={this.props.isTemplateEmpty ? 'tooltip' : null}
          >
            <PrimaryButton
              className="self-serve-builder-post-share-view-responses-button"
              disabled={this.props.isTemplateEmpty}
              onClick={
                this.props.isEditingPopup ? this.props.setPopupCreationError : this.togglePublicLink
              }
            >
              {buttonText}
            </PrimaryButton>
          </div>
        }

        {
          this.props.isTemplateEmpty &&
          <ReactTooltip
            className="empty-template-tooltip"
            place="bottom"
            type="light"
            effect="solid"
            getContent={[
              () => (
                <div>
                  {this.props.emptyTemplateTooltipText}
                </div>
              ),
            ]}
          />
        }
      </div>
    );
  }
}

PublicLinkToggle.defaultProps = {
  isEditingPopup: false,
  isIcon: true,
  isTemplateEmpty: false,
  setPopupCreationError: () => {},
};

PublicLinkToggle.propTypes = {
  documentType: PropTypes.string.isRequired,
  emptyTemplateTooltipText: PropTypes.string.isRequired,
  isEditingPopup: PropTypes.bool,
  isIcon: PropTypes.bool,
  isTemplateEmpty: PropTypes.bool,
  isToggledOn: PropTypes.bool.isRequired,
  setPopupCreationError: PropTypes.func,
  togglePublish: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/PublicLinkToggle.jsx